import workspaceQuery from 'graphql/queries/nominal/NominalAuditByFieldWorkspaceQuery.graphql';
import fragment from 'graphql/fragments/common/AuditByFieldFragment.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const NominalAuditByField = {
  type: 'AuditChange',
  formTitle: 'Nominal Audit',
  formUrl: '/Nominal/NominalAudit/Form',
  workspace: workspaceQuery,
  fragment,
  workspaceUrl: '/menu/Nominal',
  screenReference: 'NOMINAL_NOMINAL_AUDIT',
  operations: ALLOW_VIEW,
};

export default NominalAuditByField;
